var React = require('react');

function Desktop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.598 2.755h15.553c.33 0 .598-.274.598-.612V.613A.605.605 0 0028.15 0H12.598A.605.605 0 0012 .612v1.53c0 .339.268.613.598.613zm0 6.123h15.553c.33 0 .598-.275.598-.613v-1.53a.605.605 0 00-.598-.613H12.598a.605.605 0 00-.598.613v1.53c0 .338.268.613.598.613zm0 6.122h15.553c.33 0 .598-.274.598-.612v-1.53a.605.605 0 00-.598-.613H12.598a.605.605 0 00-.598.612v1.53c0 .339.268.613.598.613z","fillRule":"nonzero","fill":"#FFF"}));
}

Desktop.defaultProps = {"width":"41","height":"15"};

module.exports = Desktop;

Desktop.default = Desktop;
